import { render } from "./Recovery.vue?vue&type=template&id=00881940&scoped=true"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"

import "./Recovery.vue?vue&type=style&index=0&id=00881940&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00881940"]])

export default __exports__